import React from 'react';
// import { Tabs, Tab } from 'react-bootstrap';
import { I18n as I } from 'react-redux-i18n';

import {
  bind,
  equal,
  isArray,
  isNil,
  parseDate,
  AuctionStatuses,
  PartyTypes,
  BidStatuses,
  Memberships,
  ConfirmationModal,
  LoaderOverlay,
  formatCurrencyRounded,
} from 'vdlib';
import LookupsHelper from 'lib/LookupsHelper';

import Portlet from 'components/layout/Portlet';
import AuctionDataPaneNew from './AuctionDataPaneNew';
import AuctionNotification from './AuctionNotification';
import AuctionBidsGrid from 'components/bids/AuctionBidsGrid';
import AuctionBidModal from 'components/bids/AuctionBidModal';
import UpgradeMembershipModal from 'components/bids/UpgradeMembershipModal';
import AuctionPartsGrid from './AuctionPartsGrid';
import AuctionDurationModal from './AuctionDurationModal';
import AuctionCommentsModal from './AuctionCommentsModal';
import AuctionCancellationModal from './AuctionCancellationModal';
import OnlineAuctionsDrawerItem from './OnlineAuctionsDrawerItem';

import 'react-viewer/dist/index.css';

import AuctionInsuranceData from 'components/parties/AuctionInsuranceData';
import AuctionMerchantData from 'components/parties/AuctionMerchantData';

import { Button, Tooltip, Row, Col } from 'antd';

import getPortletActions, {
  PortletActionTypes,
} from './ui-data/AuctionPortletActions';
import AuctionImages from 'containers/auctions/AuctionImagesContainer';

const beforeSelectStatuses = [
  AuctionStatuses.Pending,
  AuctionStatuses.Active,
  AuctionStatuses.ForSelection,
];

const afterSelectFinished = [
  AuctionStatuses.ForAcceptance,
  AuctionStatuses.Finished,
];

const afterTimeFinished = [
  AuctionStatuses.Active,
  AuctionStatuses.ForSelection,
  AuctionStatuses.ForAcceptance,
  AuctionStatuses.Finished,
];

class Auction extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showAuctionDurationModal: false,
      showAuctionCommentsModal: false,
      showCancelAuctionModal: false,
      showAcceptAuctionModal: false,
      showRejectAuctionModal: false,
      showOfferAuctionModal: false,
      showUpgradeModal: false,
      showInsertOwnerInfoModal: false,
      showAuctionCancellationModal: false,
      visible: false,
      activeIndex: 0,
      cancelBidId: null, //determines if cancel bid modal is shown
      offerInfo: '',

      goldMarketValue: false,
      selectedBidId: null,
      orderBids: [],
    };

    this.isViewOnly = false;

    bind(this, [
      'init',
      'populate',
      'isAuctionStatus',
      'isValidId',
      'createBid',
      'cancelBid',
      'hideModal',
      'onBidSubmit',
      'addDays',
      'getDateFromAspNetFormat',
    ]);
  }

  componentDidMount() {
    this.init(this.props.params.id);
  }

  componentWillReceiveProps(nextProps) {
    const { auction, params, submitting } = nextProps;
    const differentId = this.props.params.id !== params.id;
    const onlineAuctionEnded =
      this.props.auction &&
      auction &&
      this.props.auction.OnlineMode === true &&
      auction.OnlineMode !== true;
    const justSubmitted =
      this.props.submitting === true && submitting === false;

    if (differentId || onlineAuctionEnded) {
      this.props.clearData();
      return setTimeout(() => this.init(params.id, onlineAuctionEnded));
    } else if (justSubmitted) {
      this.setState({
        showMerchantData: false,
        showInsuranceData: false,
        showAuctionDurationModal: false,
        showAuctionCommentsModal: false,
        showCancelAuctionModal: false,
        showAcceptAuctionModal: false,
        showOfferAuctionModal: false,
        showUpgradeModal: false,
        showAuctionCancellationModal: false,
        cancelBidId: null,
        goldMarketValue: false,
      });

      this.props.clearData();
      return setTimeout(() => this.init());
    }

    if (!equal(this.props.auction, nextProps.auction)) {
      return this.populate(nextProps);
    }

    if (
      !equal(this.props.bids, nextProps.bids) ||
      this.props.lang !== nextProps.lang
    )
      return this.populate(nextProps);

    if (!equal(this.props.insuranceData, nextProps.insuranceData)) {
      return this.populateInsuranceData(nextProps.insuranceData);
    }

    if (!equal(this.props.merchantData, nextProps.merchantData)) {
      return this.populateMerchantData(nextProps.merchantData);
    }
  }

  isValidId(id) {
    if (isNil(id)) id = this.props.params.id;

    try {
      return parseInt(id) + '' == id + '';
    } catch (e) {
      return false;
    }
  }

  isAuctionStatus(description, auction) {
    if (isNil(auction)) auction = this.props.auction;
    if (isNil(auction)) return false;
    return (
      description ===
      LookupsHelper.getDescription(this.props.auctionStatuses, auction.StatusID)
    );
  }

  init(auctionId, forceRefresh) {
    if (isNil(auctionId)) auctionId = this.props.params.id;

    if (this.isValidId(auctionId)) {
      this.props.fetchAuction(forceRefresh);
      this.props.fetchBids(auctionId);
      this.props.fetchComments(auctionId);
      this.props.fetchParts(auctionId);
    }
  }

  populateInsuranceData = insuranceData => {
    const { partyTypes, user } = this.props;

    this.setState({
      showInsuranceData:
        !isNil(insuranceData) &&
        user.PartyType !=
          LookupsHelper.getIdByDescription(partyTypes, PartyTypes.Insurance),
    });
  };

  populateMerchantData = merchantData => {
    const { partyTypes, user } = this.props;

    this.setState({
      showMerchantData:
        !isNil(merchantData) &&
        user.PartyType !=
          LookupsHelper.getIdByDescription(partyTypes, PartyTypes.Merchant),
    });
  };

  populate(props) {
    if (isNil(props)) props = this.props;

    const {
      auction,
      auctionStatuses,
      bids,
      fetchingInsurance,
      fetchingMerchant,
      partyTypes,
      user,
      merchantFees,
    } = props;

    if (bids && bids.length > 0) {
      let i = 1;
      let ordBids = props.bids.map(b => Object.assign(b, { AA: i++ }));

      this.setState({ orderBids: ordBids });
    }

    let status =
      auction != null
        ? LookupsHelper.getDescription(auctionStatuses, auction.StatusID)
        : null;

    if (auction && afterSelectFinished.indexOf(status) >= 0) {
      if (!fetchingInsurance && auction.MerchantID == user.PartyId) {
        this.props.fetchInsurance(auction.InsuranceID);
      } else if (
        !fetchingMerchant &&
        (auction.InsuranceID == user.PartyId ||
          this.partyType == PartyTypes.Operator ||
          this.partyType == PartyTypes.Admin_Insurance)
      ) {
        this.props.fetchMerchant(auction.MerchantID);
      } else if (
        (!fetchingInsurance &&
          !fetchingMerchant &&
          this.partyType == PartyTypes.Operator) ||
        this.partyType == PartyTypes.Admin_Insurance
      ) {
        this.props.fetchMerchant(auction.MerchantID);
        this.props.fetchInsurance(auction.InsuranceID);
      }
    }

    if (!isNil(auction)) {
      this.partyType = LookupsHelper.getDescription(partyTypes, user.PartyType);
      this.status = LookupsHelper.getDescription(
        auctionStatuses,
        auction.StatusID
      );

      this.cancellationReason = auction.CancellationReason || '';
      this.isViewOnly =
        this.partyType == PartyTypes.Merchant &&
        !isNil(auction.MerchantID) &&
        auction.MerchantID != user.PartyId;

      // merchant A won the auction. merchant B tries to view auction. Goodbye
      // if(this.partyType == PartyTypes.Merchant && !isNil(props.auction.MerchantID) && props.auction.MerchantID != this.props.user.PartyId)
      //   return history.replace('/auctions');

      this.portletTitle = `${auction.VehicleBrand} ${auction.VehicleModel}`;

      this.showAuctionBidsProducts =
        (this.status == AuctionStatuses.Active &&
          (this.partyType == PartyTypes.Merchant ||
            this.partyType == PartyTypes.Operator ||
            this.partyType == PartyTypes.Admin_Insurance)) ||
        (this.status == AuctionStatuses.ForSelection &&
          this.partyType != PartyTypes.Merchant);

      this.auctionBidsProducsExtraProps =
        this.showAuctionBidsProducts && this.partyType == PartyTypes.Insurance
          ? {
              auctionStatus: this.status,
              auctionPartPrice: auction.PartPrice,
              partDescription: auction.PartDescription,
              // imitationCategories: props.imitationPartCategories,
              // usedConditionTypes: props.usedConditionTypes,
              onSelectBid: props.endAuction,
            }
          : {};

      this.isOperator =
        this.partyType == PartyTypes.Operator ||
        this.partyType == PartyTypes.Admin_Insurance;
      this.showAuctionBidsGrid =
        (this.status == AuctionStatuses.ForSelection &&
          this.partyType == PartyTypes.Insurance) ||
        ((this.partyType == PartyTypes.Operator ||
          this.partyType == PartyTypes.Admin_Insurance) &&
          (this.status == AuctionStatuses.Active ||
            this.status == AuctionStatuses.ForSelection));
      this.canStartAuction =
        ((this.partyType == PartyTypes.Operator ||
          this.partyType == PartyTypes.Admin_Insurance) &&
          this.status == AuctionStatuses.Pending) ||
        this.status == AuctionStatuses.ForSelection;
      this.canSelectOffer =
        this.partyType == PartyTypes.Insurance &&
        this.status == AuctionStatuses.ForSelection;
      this.canMakeBid =
        this.partyType == PartyTypes.Merchant &&
        this.status == AuctionStatuses.Active;
      this.canCancelBid = this.canMakeBid && isArray(bids);
      this.canCancelAuction =
        (this.partyType == PartyTypes.Insurance ||
          this.partyType == PartyTypes.Operator ||
          this.partyType == PartyTypes.Admin_Insurance) &&
        (this.status == AuctionStatuses.Pending ||
          this.status == AuctionStatuses.Active ||
          this.status == AuctionStatuses.ForSelection);
      this.canAcceptAuction =
        this.partyType == PartyTypes.Merchant &&
        this.status == AuctionStatuses.ForAcceptance;
      this.hasBids = isArray(bids) && bids.length > 0;

      // create portlet actions for each role
      let portletActionsCallbacks = {
          [PortletActionTypes.StartAuction]: () =>
            this.setState({ showAuctionDurationModal: true }),
          [PortletActionTypes.CommentAuction]: () =>
            this.setState({ showAuctionCommentsModal: true }),
          [PortletActionTypes.AcceptAuction]: () =>
            this.setState({ showAcceptAuctionModal: true }),
          [PortletActionTypes.EditAuction]: () =>
            props.router.push({
              pathname: props.router.location.pathname + '/edit',
            }),
          [PortletActionTypes.RejectAuction]: () =>
            this.setState({ showRejectAuctionModal: true }),
          //[PortletActionTypes.RejectAuction]: () => props.rejectAuction(props.auction.ID),
          [PortletActionTypes.CancelAuction]: () =>
            this.setState({ showAuctionCancellationModal: true }),
          [PortletActionTypes.OfferAuction]: () =>
            this.setState({
              showOfferAuctionModal: true,
              goldMarketValue: this.props.auction.MarketValue >= 7000,
            }),
        },
        portletActionsRaw = getPortletActions(
          this.partyType,
          this.status,
          portletActionsCallbacks,
          this
        );

      this.portletActions =
        isArray(portletActionsRaw) && !this.isViewOnly
          ? portletActionsRaw.map((ra, idx) => (
              <Tooltip title={ra.title}>
                <Button
                  type="primary"
                  shape="circle"
                  style={{
                    borderColor: ra.className,
                    backgroundColor: 'white',
                    marginRight: 5,
                    borderRadius: '50% !important',
                    color: ra.className,
                  }}
                  icon={ra.icon}
                  onClick={ra.onClick}
                />
              </Tooltip>
            ))
          : false;
    }
  }

  createMerchantOfferData = (bids, auction, isGold) => {
    let offerData = {
      offerAmount: 0,
      offerText: '',
      offerDate: '',
      offerPlacement: 0,
      offerColor: 'geekblue',
      offerBest: 0,
      isGold: 0,
    };

    if (bids && bids.length) {
      offerData.isGold = isGold;
      offerData.offerAmount = bids[0].Amount;
      offerData.offerPlacement = bids[0].Placement;
      offerData.offerDate =
        bids[0].Placement === 1
          ? `${this.addMomentDays(auction.EndDate, 18)}`
          : '';
      offerData.offerText = `${
        bids[0].Placement === 1
          ? `${bids[0].Placement}η`
          : bids[0].Placement <= 3
          ? `${bids[0].Placement}η`
          : `${I.t('OFFER_SMALLER_THAN_3RD')}`
      }`;
      offerData.offerBest = isGold ? bids[0].BestOffer : null;
    }

    return offerData;
  };

  getOfferInfo = () => {
    const { auction, bids, auctionStatuses } = this.props;

    let status =
      auction != null
        ? LookupsHelper.getDescription(auctionStatuses, auction.StatusID)
        : null;

    let offerData = {
      offerAmount: 0,
      offerText: '',
      offerDate: '',
      offerPlacement: 0,
      offerColor: 'geekblue',
    };

    const isGold =
      this.props.user.MembershipId == this.getMembershipId(Memberships.Gold);

    if (auction && afterTimeFinished.indexOf(status) >= 0) {
      return this.createMerchantOfferData(bids, auction, isGold);
    } else if (auction && status == AuctionStatuses.ForAcceptance) {
      offerData.offerText = `${I.t('OFFER')} : ${
        bids && bids.length > 0
          ? `${formatCurrencyRounded(bids[0].Amount)} - ${I.t(
              'OFFER_PLACEMENT'
            )} ${bids[0].Placement}η - ${I.t(
              'OFFER_COMMITMENT_UNTIL'
            )} ${this.addDays(auction.EndDate, 18)}`
          : I.t('NO_OFFER_PLACED')
      }`;
    } else {
      offerData.offerText = `${I.t('OFFER')} : ${
        bids && bids.length > 0
          ? `${formatCurrencyRounded(bids[0].Amount)}`
          : I.t('NO_OFFER_PLACED')
      }`;
    }
  };

  getMembershipId(membership) {
    return LookupsHelper.getIdByDescription(this.props.memberships, membership);
  }

  onBidSubmit(bid) {
    if (
      this.props.user.MembershipId ==
        this.getMembershipId(Memberships.Bronze) &&
      this.props.auction.MarketValue >= 7000
    ) {
      this.setState({
        showUpgradeModal: true,
      });
    } else {
      this.props.createBid(
        this.props.auction.ID,
        [
          {
            Amount: bid,
          },
        ],
        this.props.user.PartyId
      );
    }
  }

  currentBid = bids => {
    return bids &&
      bids.filter(x => x.BidderID === this.props.user.PartyId) &&
      bids.filter(x => x.BidderID === this.props.user.PartyId).length > 0
      ? bids
          .filter(x => x.BidderID === this.props.user.PartyId)
          .reduce((max, p) => (p.Amount > max ? p.Amount : max), bids[0].Amount)
      : null;
  };

  getDateFromAspNetFormat(date) {
    const re = /-?\d+/;
    const m = re.exec(date);
    return parseInt(m[0], 10);
  }

  addDays(date, days) {
    var result = new Date(this.getDateFromAspNetFormat(date));
    result.setTime(result.getTime() + days * 24 * 60 * 60 * 1000);

    var formattedDate =
      result.getDate() +
      '-' +
      (result.getMonth() + 1) +
      '-' +
      result.getFullYear();

    return formattedDate;
  }

  addMomentDays = (date, days) => {
    var formattedDate = date.add(days, 'days').format('DD-MM-YYYY');
    return formattedDate;
  };

  selectBid = bidID => {
    this.setState({
      showInsertOwnerInfoModal: true,
      selectedBidId: bidID,
    });
  };

  renderDetail() {
    let acceptedBid =
      this.state.showMerchantData &&
      isArray(this.props.bids) &&
      this.props.bids.length > 0
        ? this.props.bids.find(
            b =>
              b.StatusID ==
              LookupsHelper.getIdByDescription(
                this.props.bidStatuses,
                BidStatuses.Won
              )
          )
        : {};

    const {
      auction,
      fetchingImages,
      images,
      comments,
      user,
      creatingAuctionBidsFor,
    } = this.props;
    const { PartPrice } = auction || {};

    return (
      <div>
        {this.showAuctionBidsGrid && (
          <Row>
            <Col xs={24}>
              <AuctionBidsGrid
                bids={this.state.orderBids || []}
                auctionStatus={this.status}
                partyType={this.partyType}
                marketValue={auction.MarketValue}
                loading={this.props.submitting}
                onSelectBid={bidID => this.selectBid(bidID)}
              />
            </Col>
          </Row>
        )}
        <Row>
          {this.state.showMerchantData && (
            <Col xs={24} xl={6}>
              <AuctionMerchantData
                data={this.props.merchantData}
                taxOffices={this.props.taxOffices}
                bidAmount={acceptedBid ? acceptedBid.Amount : 0}
                initialAmount={PartPrice}
              />
            </Col>
          )}
          {this.state.showInsuranceData && (
            <Col xs={24} xl={6}>
              <AuctionInsuranceData data={this.props.insuranceData} />
            </Col>
          )}
          <Col
            xs={24}
            xl={
              this.state.showMerchantData || this.state.showInsuranceData
                ? 18
                : 24
            }
          >
            <Row>
              <Col xs={24} xl={14}>
                <AuctionImages
                  auction={auction}
                  fetchingImages={fetchingImages}
                  images={images}
                  onImagesChanged={this.props.fetchImages}
                  className={
                    this.state.showMerchantData || this.state.showInsuranceData
                      ? 'col-sm-7'
                      : null
                  }
                />
              </Col>
              <Col xs={24} xl={10}>
                {' '}
                {auction &&
                auction.OnlineMode &&
                this.partyType == PartyTypes.Merchant ? (
                  <OnlineAuctionsDrawerItem
                    auction={auction}
                    key={auction.ID}
                    loading={creatingAuctionBidsFor === auction.ID}
                    onBid={this.onBidSubmit}
                    open={true}
                    partyId={user.PartyId}
                    merchantFees={this.props.merchantFees}
                    membershipID={this.props.user.MembershipId}
                  />
                ) : null}
                <AuctionDataPaneNew
                  auction={auction}
                  comments={comments}
                  offerInfo={this.getOfferInfo()}
                  vehicleType={LookupsHelper.getDescription(
                    this.props.vehicleTypes,
                    this.props.auction.VehicleTypeID
                  )}
                  fuelType={LookupsHelper.getDescription(
                    this.props.fuelTypes,
                    this.props.auction.FuelTypeID
                  )}
                  gearBox={LookupsHelper.getDescription(
                    this.props.gearBoxes,
                    this.props.auction.GearboxID
                  )}
                  wheelDrive={LookupsHelper.getDescription(
                    this.props.wheelDrives,
                    this.props.auction.WheeldriveID
                  )}
                  showInsurance={
                    this.partyType === PartyTypes.Operator ||
                    this.partyType == PartyTypes.Admin_Insurance ||
                    this.partyType === PartyTypes.Insurance
                  }
                  showOwnerInfo={
                    this.partyType === PartyTypes.Operator ||
                    this.partyType == PartyTypes.Admin_Insurance ||
                    this.partyType === PartyTypes.Insurance ||
                    this.status === AuctionStatuses.Finished
                  }
                  viewOnly={this.isViewOnly}
                  status={LookupsHelper.getDescription(
                    this.props.auctionStatuses,
                    auction.StatusID
                  )}
                  partyType={
                    (this.partyType = LookupsHelper.getDescription(
                      this.props.partyTypes,
                      this.props.user.PartyType
                    ))
                  }
                />
              </Col>
            </Row>
          </Col>
        </Row>

        <Row>
          <Col xs={24} xxl={14}>
            <AuctionPartsGrid
              parts={this.props.parts || []}
              loading={this.props.submitting}
            />
          </Col>
        </Row>
      </div>
    );
  }

  renderComments() {
    return (
      <div>
        <div className="row form-group">
          <br />
          <label className="control-label col-2">{I.t('FROM')}</label>
          <label className="control-label col-4">
            {isNil(this.props.comments) ? '' : this.props.comments.SenderName}
          </label>
        </div>
        <div className="row form-group">
          <br />
          <label className="control-label col-2">{I.t('COMMENTS')}</label>
          <div className="col-10">
            <textarea
              rows="4"
              className="form-control"
              readOnly={true}
              value={
                isNil(this.props.comments) ? '' : this.props.comments.Comments
              }
            />
          </div>
        </div>
      </div>
    );
  }

  render() {
    if (!this.props.user || !this.isValidId()) return false;

    let showCancelBidConfirmationModal = this.state.cancelBidId != null;

    return (
      <div className="auction-wrap">
        <LoaderOverlay loading={isNil(this.props.auction)} />
        {isNil(this.props.auction) ? null : (
          <div>
            <Portlet
              key="main"
              icon="icon-settings"
              title={this.portletTitle}
              backButtonUrl={''}
              showBackButton={true}
              showOnlineLabel={this.props.auction.IsOnlineAuction}
              actions={this.portletActions}
            >
              <div>
                {!this.isViewOnly && (
                  <AuctionNotification
                    key="auction-notification"
                    auction={this.props.auction}
                    offerInfo={this.getOfferInfo()}
                    hasBids={this.hasBids}
                    isMerchant={this.partyType == PartyTypes.Merchant}
                    status={this.status}
                    cancellationReason={this.cancellationReason}
                    partyTypeDescription={this.partyType}
                    onAuctionFinish={this.init}
                    userId={this.props.user.PartyId}
                    onBidSubmit={this.onBidSubmit}
                    currentBid={this.currentBid}
                    merchantFees={this.props.merchantFees}
                    membershipID={this.props.user.MembershipId}
                  />
                )}
                {this.renderDetail.bind(this)()}
                <div className="row" />
              </div>
            </Portlet>

            {
              // datepicker modal for starting an auction
              this.canStartAuction && (
                <AuctionDurationModal
                  title={I.t('AUCTION_APPROVAL')}
                  lang={this.props.lang}
                  show={this.state.showAuctionDurationModal}
                  submitButton={I.t('APPROVAL')}
                  loading={this.props.submitting}
                  marketValue={this.props.auction.MarketValue}
                  comments={this.props.comments && this.props.comments.Comments}
                  isOnline={this.props.auction.IsOnlineAuction}
                  onSubmit={(
                    endDate,
                    marketValue,
                    stepBid,
                    comments,
                    isOnline
                  ) =>
                    this.props.startAuction(
                      {
                        ID: this.props.auction.ID,
                        EndDate: endDate,
                        MarketValue: marketValue,
                        BidStep: stepBid,
                        IsOnlineAuction: isOnline,
                      },
                      comments
                    )
                  }
                  onHide={e =>
                    this.setState({ showAuctionDurationModal: false })
                  }
                />
              )
            }

            {this.isOperator && (
              <AuctionCommentsModal
                lang={this.props.lang}
                show={this.state.showAuctionCommentsModal}
                loading={this.props.submitting}
                comments={
                  isNil(this.props.comments) ? '' : this.props.comments.Comments
                }
                onSubmit={comments =>
                  this.props.commentAuction(
                    this.props.auction.ID,
                    this.props.auction.StatusID,
                    comments
                  )
                }
                onHide={e => this.setState({ showAuctionCommentsModal: false })}
              />
            )}

            {this.canMakeBid && (
              <AuctionBidModal
                isBronze={
                  this.props.user.MembershipId ==
                    this.getMembershipId(Memberships.Bronze) &&
                  this.state.goldMarketValue
                }
                show={this.state.showOfferAuctionModal}
                onHide={() => this.setState({ showOfferAuctionModal: false })}
                loading={this.props.submitting}
                onSubmit={this.onBidSubmit}
                bids={this.props.bids}
                membershipID={this.props.user.MembershipId}
              />
            )}

            {this.canMakeBid && (
              <UpgradeMembershipModal
                show={this.state.showUpgradeModal}
                onHide={() => this.setState({ showUpgradeModal: false })}
              />
            )}

            {this.canSelectOffer && (
              <ConfirmationModal
                promptText={I.t('OWNER_INFO_INSERT')}
                loading={this.props.submitting}
                withComments={true}
                commentsLabel={I.t('INFO')}
                onHide={() =>
                  this.setState({ showInsertOwnerInfoModal: false })
                }
                show={this.state.showInsertOwnerInfoModal}
                rejectButton={false}
                submitButton={I.t('SAVE')}
                onSubmit={(data, ownerInfo) =>
                  this.props.endAuction(this.state.selectedBidId, ownerInfo)
                }
              />
            )}

            {this.canCancelBid && (
              <ConfirmationModal
                promptText={I.t('MODAL_QUESTION_OFFER_DELETE')}
                loading={this.props.submitting}
                withComments={false}
                onHide={() => this.setState({ cancelBidId: null })}
                show={showCancelBidConfirmationModal}
                rejectButton={false}
                onSubmit={() => this.props.cancelBid(this.state.cancelBidId)}
              />
            )}

            {this.canCancelAuction && (
              <AuctionCancellationModal
                show={this.state.showAuctionCancellationModal}
                submitButton={I.t('SAVE')}
                loading={this.props.submitting}
                onSubmit={cancellationReason =>
                  this.props.cancelAuctionWithReason(
                    this.props.auction.ID,
                    cancellationReason
                  )
                }
                onHide={e =>
                  this.setState({ showAuctionCancellationModal: false })
                }
                cancellationReasons={this.props.cancellationReasons}
              />
            )}
            {this.canAcceptAuction && (
              <ConfirmationModal
                promptText={I.t('OFFER_APPROVE_ASK')}
                loading={this.props.submitting}
                title={I.t('OFFER_APPROVE')}
                withComments={false}
                rejectButton={false}
                onHide={() => this.setState({ showAcceptAuctionModal: false })}
                show={this.state.showAcceptAuctionModal === true}
                onSubmit={this.props.acceptAuction}
              />
            )}
            {this.canAcceptAuction && (
              <ConfirmationModal
                promptText={I.t('MODAL_QUESTION_OFFER_REJECT')}
                loading={this.props.submitting}
                title={I.t('OFFER_REJECT')}
                withComments={false}
                rejectButton={false}
                onHide={() => this.setState({ showRejectAuctionModal: false })}
                show={this.state.showRejectAuctionModal === true}
                onSubmit={(data, comments) =>
                  this.props.rejectAuction(comments)
                }
              />
            )}
          </div>
        )}
      </div>
    );
  }
}

export default Auction;
